import React from 'react';
import { useNavigate } from 'react-router-dom';
import AnalyticsSection from './AnalyticsSection';

const FullscreenAnalytics = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen w-full bg-stone-100">
            <header className="sticky top-0 z-20 bg-white/95 backdrop-blur-sm border-b border-stone-200 shadow-sm">
                <div className="w-full px-3 sm:px-5 py-2">
                    <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-2 min-w-0">
                            <button
                                type="button"
                                onClick={() => navigate(-1)}
                                className="flex-shrink-0 p-1.5 rounded-lg bg-stone-100 text-stone-700 hover:bg-stone-200 transition-colors"
                                aria-label="Back"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <div>
                                <h1 className="text-base font-bold text-stone-800">Food Analytics</h1>
                                <p className="text-[10px] text-stone-500">Fullscreen view</p>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <main className="w-full">
                <AnalyticsSection isFullscreen={true} />
            </main>
        </div>
    );
};

export default FullscreenAnalytics;